/**
 * Generates trigrams for text search indexing
 * Trigrams are three-character sequences used for efficient text searching
 */
export function generateTrigrams(text: string): Record<string, boolean> {
  const trigrams: Record<string, boolean> = {};
  const trimmedText = text.replace(/\s/g, "").toLowerCase();

  if (trimmedText.length >= 3) {
    for (let i = 0; i < trimmedText.length - 2; i++) {
      const trigram = trimmedText.slice(i, i + 3);
      trigrams[trigram] = true;
    }
  }

  return trigrams;
}
